import React from 'react';

import { Container, Text } from '@/atoms';
import { CardStep, WithPaperBorder } from '@/molecules';
import { Positions } from '@/molecules/with-paper-border/types';
import SliderStepper from '@/organisms/slider-stepper';

import { containerTransformer } from '@/lib/graphql/transformers';

/**
 * Stepper
 */
const StepperSlider = ({ bloque, id, className }: any) => (
  <WithPaperBorder
    id={id}
    top={
      bloque.papelRasgado.zona === Positions.top ||
      bloque.papelRasgado.zona === Positions.topBottom
    }
    bottom={
      bloque.papelRasgado.zona === Positions.bottom ||
      bloque.papelRasgado.zona === Positions.topBottom
    }
    border={bloque.papelRasgado.border}
    borderHeight={bloque.papelRasgado.borderHeight}
    borderColor={bloque.papelRasgado.borderColor}
  >
    <Container
      id={bloque?.id ?? id}
      as="section"
      padding="px-4 py-8"
      {...containerTransformer({
        colorDeFondo: bloque.background,
      })}
      {...(className && { className })}
    >
      {(bloque.pretitulo || bloque.titulo) && (
        <div className="my-4 flex w-full flex-col items-center">
          {bloque.pretitulo && (
            <p className="u-actions--link mb-4 block text-secondary-500">
              {bloque.pretitulo}
            </p>
          )}

          {bloque.titulo && (
            <Text as={bloque.headingType} className="u-headline u-headline--h2">
              {bloque.titulo}
            </Text>
          )}
        </div>
      )}
      {/*TODO(Sergio): Mover los step bullets a su propio componente*/}
      <SliderStepper>
        {bloque.steps.map((step: any, index: number) => (
          <React.Fragment key={index}>
            <div className="relative mb-6 flex flex-col items-center gap-1 overflow-hidden">
              {bloque.stepBulletText && (
                <p className="u-label u-label--overlline text-primary-900">
                  {bloque.stepBulletText}
                </p>
              )}
              <div
                className={`flex h-10 w-10 items-center justify-center rounded-full bg-primary-900 ${
                  index < bloque.steps.length - 1
                    ? "after:content-['']"
                    : 'after:content-none'
                } after:absolute after:-right-9 after:h-px after:w-1/2 after:bg-primary-900 ${
                  index > 0 ? "before:content-['']" : 'before:content-none'
                } before:absolute before:-left-9 before:h-px before:w-1/2 before:bg-primary-900`}
              >
                <span className="u-body u-body--xl text-typo-alternative">
                  {index + 1}
                </span>
              </div>
            </div>
            <CardStep
              key={index}
              image={step?.imagen}
              pretitle={step.pretitle}
              subtitle={step.subtitulo}
              title={step.titulo}
              size={bloque.size}
              stroke={bloque.stroke}
              description={step?.descripcion}
              button={step?.button}
              headingType={step.headingType}
            />
          </React.Fragment>
        ))}
      </SliderStepper>
    </Container>
  </WithPaperBorder>
);

StepperSlider.displayName = 'FlexibleStepperSlider';

export default StepperSlider;
